import { render, staticRenderFns } from "./UserAdminDirectMatching.vue?vue&type=template&id=01d5d88e"
import script from "./UserAdminDirectMatching.vue?vue&type=script&lang=js"
export * from "./UserAdminDirectMatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports